import React from "react";
import type {TabsProps} from "antd";
import {HistoryExamine} from "components/common";
import {tabKeys} from "types/enums";
import TechnicalService from "./TechnicalService";
import Service from "./tabs/Service/Service";
import Catalog from "./tabs/Catalog/Catalog";

const items: TabsProps["items"] = [
  {
    key: tabKeys.TECHNICAL_SERVICE.TECHNICAL_SERVICE,
    label: `Dịch vụ kỹ thuật`,
    children: <Service/>,
  },
  {
    key: tabKeys.TECHNICAL_SERVICE.CATALOG,
    label: `Danh mục`,
    children: <Catalog />
  }
];
export {items};
